// extracted by mini-css-extract-plugin
export var title = "welcome-module--title--cc38b";